import firebase from "firebase/app";
import {
    GET_REQUESTED_TMS,
    SET_ROWS_PER_PAGE,
    SET_PAGE,
    SET_REPORT_STATUS,
    SET_SELECTED_ROW,
    SET_REPORT_EDIT_STATUS,
    SET_STATUS_CHANGE_MODAL_INFO,
    DELETE_REPORT,
    SET_DELETE_STATUS,
    GET_TMPLAN_TMS,
    GET_REQUESTED_ENDPOINTS
} from "./types";
import axios from 'axios'


export const getEndPoints = () => {
    return dispatch => {
        dispatch({ type: GET_REQUESTED_ENDPOINTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_REQUESTED_ENDPOINTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/database_endpoints")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REQUESTED_ENDPOINTS.SUCCESS,
                                payload: snapshot.val()

                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REQUESTED_ENDPOINTS.FAIL });
        }
    };
};

export const getTmPlans = () => dispatch => {
    axios
        .get(`https://us-central1-proworkcorkcocodb01.cloudfunctions.net/getRequestedTMPlans`)

        .then(res =>

            dispatch({
                type: GET_TMPLAN_TMS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_TMPLAN_TMS,
                payload: null
            })
        );

};

export const getUserData = (planRef) => {
    return dispatch => {
        dispatch({ type: GET_REQUESTED_TMS.REQUEST });

        try {
            axios
                .get(`${planRef}`)
                .then(res =>
                    dispatch({
                        type: GET_REQUESTED_TMS.SUCCESS,
                        payload: res.data
                    })
                )
        } catch {
            dispatch({ type: GET_REQUESTED_TMS.FAIL });
        }
    };
};

export const getData = (endpoints) => {
    let dataList = [];
    let dataObj = {};
    return dispatch => {
        dispatch({ type: GET_REQUESTED_TMS.REQUEST });

        try {
            for (let k = 0; k < endpoints.length; k++) {
                axios
                    .get(`${endpoints[k]}`)
                    .then(res => {
                        for (var i in res.data)
                            dataList.push([i, res.data[i]]);

                        if (k === endpoints.length - 1) {
                            for (i = 0; i < dataList.length; i++) {
                                let obj = dataList[i]
                                dataObj[obj[0]] = obj[1];
                            }
                            dispatch({
                                type: GET_REQUESTED_TMS.SUCCESS,
                                payload: dataObj
                            })
                        }

                    })
            }
        } catch {
            dispatch({ type: GET_REQUESTED_TMS.FAIL });
        }
    };
};


export const setRowsPerPage = (rows = 50) => {
    return dispatch => {
        dispatch({ type: SET_ROWS_PER_PAGE, payload: rows });
    };
};
export const setPage = (page = 1) => {
    return dispatch => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};

export const setReportStatus = ({
    status = "unviewed",
    uid = false,
    reportType = false,
    timestamp = false
} = {}) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${uid}/reports/${reportType}`)
                            .child(timestamp)
                            .update({ worksheet_status: status })
                            .then(() =>
                                dispatch({ type: SET_REPORT_STATUS.SUCCESS })
                            )
                            .catch(() =>
                                dispatch({ type: SET_REPORT_STATUS.FAIL })
                            );
                    } else {
                        dispatch({ type: SET_REPORT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_STATUS.FAIL });
        }
    };
};

export const setSelectedRow = (row = false) => {
    return dispatch => {
        dispatch({ type: SET_SELECTED_ROW, payload: row });
    };
};
export const setReportEditStatus = ({
    uid = false,
    reportType = false,
    timestamp = false,
    status = false
} = {}) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_EDIT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/reports/${reportType}/${timestamp}`
                            )
                            .update({ uneditable: status })
                            .then(() =>
                                dispatch({
                                    type: SET_REPORT_EDIT_STATUS.SUCCESS
                                })
                            )
                            .catch(() => ({
                                type: SET_REPORT_EDIT_STATUS.FAIL
                            }));
                    } else {
                        dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
        }
    };
};

export const setStatusChangeModal = ({
    state = false,
    status = false,
    uid = false,
    reportType = false,
    timestamp = false,
    type = false,
    subjectName = false,
    subjectChild = false
} = {}) => {
    return dispatch => {
        dispatch({
            type: SET_STATUS_CHANGE_MODAL_INFO,
            payload: {
                state,
                status,
                uid,
                reportType,
                timestamp,
                type,
                subjectName,
                subjectChild
            }
        });
    };
};
export const deleteReport = (timestamp = false) => {
    return dispatch => {
        dispatch({ type: DELETE_REPORT.REQUEST });
        if (timestamp) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/requested_tm_plans/${timestamp}`)
                            .remove()
                            .then(() => {
                                dispatch({ type: DELETE_REPORT.SUCCESS });
                            })
                            .catch(() =>
                                dispatch({ type: DELETE_REPORT.FAIL })
                            );
                    } else {
                        dispatch({ type: DELETE_REPORT.FAIL });
                    }
                });
            } catch {
                dispatch({ type: DELETE_REPORT.FAIL });
            }
        } else {
            dispatch({ type: DELETE_REPORT.FAIL });
        }
    };
};
export const setDeleteStatus = () => {
    return dispatch => {
        dispatch({ type: SET_DELETE_STATUS });
    };
};
